import { Component } from '@angular/core';
import { BasePage } from '../BasePage';

@Component({
  selector: 'app-leads-page',
  templateUrl: './leads-page.component.html',
  standalone: false,
})
export class LeadsPageComponent extends BasePage {}
